import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("@/pages/index/index.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/innerpages/auth-pages/login.vue"),
  },
  // Bring this back end
  {
    path: "/register",
    name: "register",
    component: () => import("@/pages/innerpages/auth-pages/register.vue"),
  },
  {
    path: "/signup-success",
    name: "make-payment",
    component: () => import("@/pages/innerpages/auth-pages/signup-success.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/pages/innerpages/contact.vue"),
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("@/pages/admin/index.vue"),
    children: [
      {
        path: "",
        redirect: "confirmPayment",
      },
      {
        path: "/confirmPayment",
        name: "confirmPayment",
        component: () => import("@/pages/admin/confirmPayment.vue"),
      },
      {
        path: "/printCard",
        name: "printId",
        component: () => import("@/pages/admin/printId.vue"),
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/pages/innerpages/special-pages/404.vue"),
    meta: { public: true },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const publicPages = [
    "/login",
    "/register",
    "/",
    "/contact",
    "/signup-success",
    "/:catchAll(.*)",
  ];
  const authRequired = !publicPages.includes(to.path) && !to.meta.public;
  const token = localStorage.getItem("token");

  if (authRequired && !token) {
    // Not authenticated, redirect to login
    return next("/login");
  }

  if (publicPages.includes(to.path) && token) {
    // Authenticated user trying to access login/register, redirect to dashboard
    return next("/admin");
  }

  // Allow navigation
  next();
});

export default router;
